/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Order_ConfirmedInputs */

const vi_status_order_confirmed = /** @type {(inputs: Status_Order_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xác nhận`)
};

/**

* @param {Status_Order_ConfirmedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const status_order_confirmed = /** @type {((inputs?: Status_Order_ConfirmedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Order_ConfirmedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_status_order_confirmed(inputs)
});